import { useState, useEffect } from 'react';

export const useNetworkStatus = () => {
  // Initialize with the current online status
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    // Function to handle online status
    const handleOnline = () => {
      setIsOnline(true);
    };

    // Function to handle offline status
    const handleOffline = () => {
      setIsOnline(false);
    };

    // Add event listeners when component mounts
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Cleanup function to remove event listeners when component unmounts
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []); // Empty dependency array means this effect runs once on mount

  return isOnline;
};
